import { Route, Routes } from 'react-router-dom';

import BusinessIntroduction from '../BusinessIntroduction/BusinessIntroduction';
import CheckEligibility from '../CheckEligibility/CheckEligibility';
import Offers from '../Offers/offers/Offers';
import PersonalInformation from '../PersonalInformation/PersonalInformation';
import RouteLoader from '../RouteLoader/RouteLoader';
import TradingHistory from '../TradingHistoryV2/TradingHistory';

const SignupRoutesUK = () => {
    return (
        <>
            <Routes>
                {/* UK routes */}
                <Route path="/business" element={<BusinessIntroduction />} />
                <Route path="/applicant" element={<PersonalInformation />} />
                <Route path="/offers" element={<Offers />} />
                <Route
                    path="/checkEligibility"
                    element={<CheckEligibility />}
                />

                <Route path="/documents" element={<TradingHistory />} />

                {/* Fallback route */}
                <Route path={'/*'} element={<RouteLoader />} />
            </Routes>
        </>
    );
};

export default SignupRoutesUK;
